package ext

import common.dto.Vec2d
import three.js.Vector2
import kotlin.math.roundToInt

fun Vec2d.asVector2() = Vector2(x, y)
fun Vector2.asVec2d() = Vec2d(x.toDouble(), y.toDouble())

fun Vector2.set(vec2d: Vec2d) = apply {
    set(vec2d.x, vec2d.y)
}

fun Vector2.set(vector2: Vector2) = apply {
    set(vector2.x, vector2.y)
}

// Operators
operator fun Vec2d.plus(vec2d: Vec2d) = Vec2d(x + vec2d.x, y + vec2d.y)
operator fun Vec2d.minus(vec2d: Vec2d) = Vec2d(x - vec2d.x, y - vec2d.y)
operator fun Vec2d.times(scalar: Double) = Vec2d(x * scalar, y * scalar)
operator fun Vec2d.div(scalar: Double) = Vec2d(x / scalar, y / scalar)
operator fun Vec2d.unaryMinus() = Vec2d(-x, -y)

/**
 * Round the three components to the nearest multiple of [stepSize].
 */
fun Vec2d.roundStepped(stepSize: Double) = Vec2d(
    (x / stepSize).roundToInt() * stepSize,
    (y / stepSize).roundToInt() * stepSize,
)